import noop from '../../../utils/noop';
import delay from '../../../utils/delay';
import VideoEditorApi from '../videoEditorApi';
import { TaskStatus, TaskWithProgress } from '../../../types/video';

import { RequestPreviewOptions } from './types';

const POLL_TIMEOUT = 1000;

class VideoPreview {
  constructor(private videoEditorApiService: VideoEditorApi) {}

  requestPreview = async (
    url: string,
    { onProgress = noop, signal }: RequestPreviewOptions,
  ): Promise<TaskWithProgress<{ url: string }, number>> => {
    const preprocessingTask = await this.videoEditorApiService.createPreprocessingTask(url, signal);

    // error or abort
    if (preprocessingTask.status !== TaskStatus.Done) {
      return preprocessingTask;
    }

    while (true) {
      const task = await this.videoEditorApiService.getTaskById(preprocessingTask.taskId, signal);

      if (task.status === TaskStatus.InProgress) {
        onProgress(task.progress);
        await delay(POLL_TIMEOUT);
      } else {
        return task;
      }
    }
  };
}

export default VideoPreview;
